<app-button (clicked)="toggleThreadFiles()" pTooltip="Files" variant="outlined" severity="contrast" icon="folder-closed"
    iconSource="lucide"></app-button>

<app-attachment-group [attachments]="chatAttachments()" [dialogMode]="true" [(dialogVisible)]="showThreadFiles"
    [canRemove]="false" [canOpen]="true" [restrictInputFiles]="isPublicView()" [threadId]="threadId()"
    [threadTitle]="threadTitle()" (openAttachment)="onOpenAttachment($event)" [loading]="loadingFiles()">
</app-attachment-group>
